import { Box, makeStyles } from "@material-ui/core";
import * as React from "react";

import { PublicHeader } from "@/components/PublicHeader";
import { useDevice } from "@/hooks/useDevice";
import theme from "@/theme";

const useStyles = makeStyles(() => ({
  root: { minHeight: "100vh", backgroundColor: theme.palette.semantic["surface/base"] },
  main: {
    width: "100%",
    padding: "32px 24px 64px",
    margin: "0 auto",
    [theme.breakpoints.up("md")]: { width: 560, padding: "48px 0 64px" },
  },
  start: {
    backgroundColor: theme.palette.semantic["surface/card"],
    [theme.breakpoints.up("md")]: {
      padding: "40px 48px",
      borderRadius: 16,
      margin: "48px auto 64px",
    },
  },
  startRoot: {
    backgroundColor: theme.palette.semantic["surface/card"],
    [theme.breakpoints.up("md")]: { backgroundColor: theme.palette.semantic["surface/base"] },
  },
  list: { [theme.breakpoints.up("md")]: { width: 720 } },
  phases: { marginBottom: 24 },
  fullBleed: { padding: "20px 0 32px", [theme.breakpoints.up("md")]: { padding: "48px 0 64px" } },
  insetPhases: { marginLeft: 24, marginRight: 24 },
}));

/** プランナー紹介専用の枠。PCの入口だけ白いカード、説明・一覧・状態は淡い地に置く。 */
export const PlannerIntroductionLayout: React.FC<{
  children: React.ReactNode;
  phaseTags?: React.ReactNode;
  mode?: "start" | "intro" | "list" | "state";
  fullBleed?: boolean;
}> = ({ children, phaseTags, mode = "intro", fullBleed = false }) => {
  const classes = useStyles();
  const { isMobile } = useDevice();
  return (
    <Box className={`${classes.root} ${mode === "start" ? classes.startRoot : ""}`}>
      {!isMobile && <PublicHeader />}
      <Box
        component="main"
        className={`${classes.main} ${mode === "start" ? classes.start : mode === "list" ? classes.list : ""} ${fullBleed ? classes.fullBleed : ""}`}
      >
        {phaseTags && <Box className={`${classes.phases} ${fullBleed ? classes.insetPhases : ""}`}>{phaseTags}</Box>}
        {children}
      </Box>
    </Box>
  );
};

export const plannerIntroductionActionStyles = {
  width: "100%",
  margin: "32px auto 0",
  [theme.breakpoints.up("md")]: { maxWidth: 360 },
};
